var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-settings" } }, [
    _c("div", { staticClass: "settings-menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 0 },
          on: {
            click: function ($event) {
              return _vm.setActive(0)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("settings")]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 1 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("mail")]),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 2 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("account_tree")]),
          _vm._v(" "),
          _vm._m(2),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 3 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("thumb_up")]),
          _vm._v(" "),
          _vm._m(3),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 4 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [
            _vm._v("integration_instructions"),
          ]),
          _vm._v(" "),
          _vm._m(4),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.activeItem === 0
          ? _c("FormDetail", {
              attrs: { formId: _vm.formId, siteId: _vm.siteId },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("FORM AYARLARI")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Form durumu ve özelliklerini değiştirin."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("E-POSTALAR")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "Otomatik yanıtlayıcı e-postalar ve bildirim e-postaları gönderin"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("KOŞULLAR")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "Form girişlerine göre eylemleri tetikleyen koşullu mantık bölümü"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("TEŞEKKÜR SAYFASI")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Form gönderildikten sonra gösterilen sayfa"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("ENTEGRASYONLAR")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("Formunuzu diğer uygulamalara bağlayın"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }